// import { useState } from "react";
// import axiosClient from "../api/axiosClient";
// import { useNavigate } from "react-router-dom";

// export default function Register() {
//   const [email, setEmail] = useState("");
//   const [username, setName] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const submit = async () => {
//     await axiosClient.post("/auth/register", { username,email, password });
//     navigate("/login");
//   };

//   return (
//     <div className="form-container">
//       <h2>Register</h2>

//       <input placeholder="name" onChange={(e) => setName(e.target.value)} />
//       <input placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
//       <input
//         placeholder="Password"
//         type="password"
//         onChange={(e) => setPassword(e.target.value)}
//       />

//       <button onClick={submit}>Register</button>
//     </div>
//   );
// }


import { useState } from "react";
import axiosClient from "../api/axiosClient";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  InputAdornment,
  Divider
} from "@mui/material";
import {
  Person,
  Email,
  Lock,
  PersonAdd,
  ArrowBack
} from "@mui/icons-material";

export default function Register() {
  const [email, setEmail] = useState("");
  const [username, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async () => {
    if (!username.trim() || !email.trim() || !password.trim()) {
      setError("All fields are required");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await axiosClient.post("api/auth/register", { username, email, password });
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      submit();
    }
  };

  return (
    <Container 
      maxWidth="sm" 
      sx={{ 
        py: 4,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          width: "100%",
          // background: "linear-gradient(135deg, #3E1E68 0%, #5D2F77 100%)",
          background:"#2a1c32ff",
          color: "white",
          borderRadius: 3
        }}
      >
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 1 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate("/")}
            sx={{
              color: "white",
              position: "absolute",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)"
              }
            }}
          />
          <PersonAdd sx={{ fontSize: 48, mb: 2, opacity: 0.9 }} />
          <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
            Create Account
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.8 }}>
            Join us and start organizing your notes
          </Typography>
        </Box>

        {/* Error Alert */}
        {error && (
          <Alert 
            severity="error" 
            sx={{ 
              mb: 3, 
              borderRadius: 2,
              backgroundColor: "rgba(255,255,255,0.1)",
              color: "white"
            }}
          >
            {error}
          </Alert>
        )}

        {/* Form */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="subtitle2" sx={{ color: "white",}}>
    Full Name
  </Typography>
          <TextField
            // label="Full Name"
            variant="outlined"
            value={username}
            onChange={(e) => setName(e.target.value)}
            onKeyPress={handleKeyPress}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Person sx={{ color: "white" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: 2,
                "&:hover fieldset": {
                  borderColor: "#ffffff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ffffff"
                }
              },
              "& .MuiInputLabel-root": {
                color: "white"
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "white"
              }
            }}
          />
<Typography variant="subtitle2" sx={{ color: "white",}}>
    Email
  </Typography>
          <TextField
            // label="Email Address"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Email sx={{ color: "white" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: 2,
                "&:hover fieldset": {
                  borderColor: "#ffffff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ffffff"
                }
              },
              "& .MuiInputLabel-root": {
                color: "white"
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "white"
              }
            }}
          />
          <Typography variant="subtitle2" sx={{ color: "white",}}>
    Password
  </Typography>

          <TextField
            // label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock sx={{ color: "white" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: 2,
                "&:hover fieldset": {
                  borderColor: "#ffffff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ffffff"
                }
              },
              "& .MuiInputLabel-root": {
                color: "white"
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "white"
              }
            }}
          />

          {/* Register Button */}
          <Button
            variant="contained"
            onClick={submit}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : <PersonAdd />}
            sx={{
              backgroundColor: "white",
              color: "#3E1E68",
              py: 1.5,
              fontWeight: "bold",
              fontSize: "1.1rem",
              borderRadius: 2,
              mt: 2,
              "&:hover": {
                backgroundColor: "#f5f5f5",
                transform: "translateY(-2px)",
                boxShadow: 3
              },
              "&:disabled": {
                backgroundColor: "rgba(255,255,255,0.5)"
              }
            }}
          >
            {loading ? "Creating Account..." : "Register"}
          </Button>

          <Divider sx={{ backgroundColor: "rgba(255,255,255,0.3)", my: 2 }} />

          {/* Login Link */}
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
              Already have an account?
            </Typography>
            <Button
              component={Link}
              to="/login"
              variant="outlined"
              sx={{
                color: "white",
                borderColor: "white",
                "&:hover": {
                  borderColor: "white",
                  backgroundColor: "rgba(255,255,255,0.1)"
                }
              }}
            >
              Sign In
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}